module.exports = __webpack_public_path__ + "img/安平丝网与养猪.c6b653ad.jpg";